import { LocationIcon } from '@hero/web-icons';

export interface CityNameProps {
  city: string;
  hideIcon?: boolean;
}

export function CityName({ city, hideIcon = false }: CityNameProps) {
  if (!city) return null;

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600 border border-blue-200 flex-shrink-0">
      {!hideIcon && <LocationIcon className="size-3 text-gray-500" />}
      {city}
    </span>
  );
}
